<template>
  <CHeader fixed with-subheader light>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      v-c-emit-root-event:toggle-sidebar-mobile
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      v-c-emit-root-event:toggle-sidebar
    />
    <CHeaderBrand
      class="mx-auto d-lg-none"
      src="img/brand/sf-logo.svg"
      width="190"
      height="46"
      alt="sf Logo"
    />
    <CHeaderNav class="d-md-down-none mr-auto">

    </CHeaderNav>
    <CHeaderNav class="mr-4">
        <div class="d-md-down-none mx-2">
            <b-button variant="link" target="_blank" class="text-app mr-3" style="font-size: 1.6rem" href="https://www.facebook.com/superformicf/" size="sm"><i class="fab fa-facebook"></i></b-button>
            <!-- <b-button variant="link" target="_blank" class="text-app mr-3" style="font-size: 1.6rem" href="https://twitter.com/superformicf" size="sm"><i class="fab fa-twitter"></i></b-button> -->
            <b-button variant="link" target="_blank" class="text-app mr-3" style="font-size: 1.6rem" href="https://www.instagram.com/superformproducts/" size="sm"><i class="fab fa-instagram"></i></b-button>
            <b-button variant="link" target="_blank" class="text-app mr-5" style="font-size: 1.6rem" href="https://www.youtube.com/channel/UCHmH6GAO1rt0USmGtI1_K-g" size="sm"><i class="fab fa-youtube"></i></b-button>
            <b-button variant="sf" class="text-white rounded-pill" style="font-size: 0.8rem" href="tel:+14036273555p3" size="sm">Questions or concerns? Call us at (403)627-3555 ext.3</b-button>
        </div>
      <div class="d-md-down-none mx-2">
        <b-button variant="dark" class="rounded-pill" style="font-size: 0.8rem" size="sm" v-b-modal.support-ticket-modal>
          <CIcon name="cil-life-ring"/> Submit a Ticket
          </b-button>
      </div>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="pr-3">
      <CButton class="btn-sf" shape="square" @click="$router.go(-1)">
        <CIcon :content="$options.freeSet.cilArrowLeft"/>
      </CButton>
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
    <ticket-modal modal_id="support-ticket-modal"></ticket-modal>
    <customer-validation-modal modal_id="customer-validation-modal"></customer-validation-modal>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import { freeSet } from '@coreui/icons'
import TicketModal from "../components/tickets/TicketModal";
import CustomerValidationModal from '../components/customers/validation/CustomerValidationModal.vue';

export default {
  name: 'TheHeader',
  freeSet,
  components: {
    TicketModal,
    TheHeaderDropdownAccnt,
    CustomerValidationModal
  }
}
</script>
